import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import Imgbase64uploderPlugin from 'src/app/helpers/CKeditor/imgbase64uploder';
import { ToastrService } from 'ngx-toastr';
import * as ClassicEditor from '../../../../../../src/ckeditor';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-email-signature',
  templateUrl: './email-signature.component.html',
  styleUrls: ['./email-signature.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EmailSignatureComponent implements OnInit, OnDestroy {
  confirmDialogRef: MatDialogRef<any>;
  isspiner: boolean = false;
  isLoadingResults: boolean = false;
  theme_type = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';

  htmlCss: SafeHtml;
  signatureType: any = 'simple';
  ckeditorValue: any = '';
  configsOption: any;
  public Editor = ClassicEditor;
  sub: Subscription;
  sub1: Subscription;

  constructor(
    private sanitizer: DomSanitizer,
    private _mainAPiServiceService: MainAPiServiceService,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    private behaviorService: BehaviorService,
  ) {
    // localStorage.setItem('istrackid', 'SystemSettingLookupsComponent');
    // this.behaviorService.APIretryCall$.subscribe((result) => {
    //   if (localStorage.getItem('istrackid') == 'SystemSettingLookupsComponent' && result['click'] && result['data']['SetLookup']) {
    //     this.saveLookups();
    //   }
    // })
    this.configsOption = {
      fontSize: {
        options: [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72],
      },
      fontFamily: {
        options: [
          'Arial',
          'Bahnschrift',
          'Calibri',
          'Cambria',
          '"Cambria Math"',
          'Candara',
          '"Comic Sans MS"',
          'Consolas',
          'Constantia',
          'Corbel',
          '"Courier New"',
          'Ebrima',
          '"Franklin Gothic"',
          'Gabriola',
          'Gadugi',
          'Georgia',
          '"Global Monospace"',
          '"Global Sans Serif"',
          '"Global Serif"',
          '"Global User Interface"',
          '"HoloLens MDL2 Assets"',
          'Impact',
          '"Ink Free"',
          '"Javanese Text"',
          '"Leelawadee UI"',
          '"Lucida Console"',
          '"Lucida Sans Unicode"',
          '"Malgun Gothic"',
          'Marlett',
          '"Microsoft Himalaya"',
          '"Microsoft JhengHei UI"',
          '"Microsoft JhengHei"',
          '"Microsoft New Tai Lue"',
          '"Microsoft PhagsPa"',
          '"Microsoft Sans Serif"',
          '"Microsoft Tai Le"',
          '"Microsoft YaHei UI"',
          '"Microsoft Yi Baiti"',
          'MingLiU-ExtB',
          'MingLiU_HKSCS-ExtB',
          '"Mongolian Baiti"',
          '"MS Gothic"',
          '"MS PGothic"',
          '"MS UI Gothic"',
          '"MV Boli"',
          '"Myanmar Text"',
          '"Nirmala UI"',
          '"Palatino Linotype"',
          'PMingLiU-ExtB',
          '"Segoe MDL2 Assets"',
          '"Segoe Print"',
          '"Segoe Script"',
          '"Segoe UI Emoji"',
          '"Segoe UI Historic"',
          '"Segoe UI Symbol"',
          '"Segoe UI"',
          'SimSun-ExtB',
          '"Sitka Banner"',
          '"Sitka Display"',
          '"Sitka Heading"',
          '"Sitka Small"',
          '"Sitka Subheading"',
          '"Sitka Text"',
          'Sylfaen',
          'Symbol',
          'Tahoma',
          '"Times New Roman"',
          '"Trebuchet MS"',
          'Verdana',
          'Webdings',
          'Wingdings',
          '"Yu Gothic UI"',
          '"Yu Gothic"',
        ],
      },
      extraPlugins: [Imgbase64uploderPlugin],
      toolbar: {
        items: [
          'heading',
          'alignment',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          '|',
          'underline',
          'bold',
          'italic',
          '|',
          'link',
          'bulletedList',
          'numberedList',
          '|',
          'Image',
          'UploadImage',
          'EasyImage',
          // 'insertImage',
          'blockQuote',
        ],
      },
      image: {
        // Configure the available styles.
        styles: ['alignLeft', 'alignCenter', 'alignRight'],
      },
    };
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingSystemSetting('email-signature');
    this.getData();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
  }

  /**
   * This function is used to Change the value data
   */
  onValChange(value) {
    this.signatureType = value;
    this.htmlCss = this.sanitizer.bypassSecurityTrustHtml(this.ckeditorValue);
  }

  /**
   * This function is used ot get the Data value.
   */
  getData(): void {
    this.isLoadingResults = true;
    this.sub = this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: {} }, 'preference')
      .subscribe({
        next: (response) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            let DefultVal: any = response.DATA;
            this.ckeditorValue = DefultVal.SIGNATUREDEFAULT;
            this.isLoadingResults = false;
          } else {
            this.isLoadingResults = false;
          }
        },
        error: (error) => {
          this.isLoadingResults = false;
          this.toastr.error(error);
        },
      });
  }

  /**
   * This function is used to update the Signature data value
   */
  async updateSignatures() {
    let contentString = this.ckeditorValue;
    let htmlObject = document.createElement('div');
    htmlObject.innerHTML = contentString;
    let allFigures = htmlObject.getElementsByTagName('figure');

    let safeText = contentString ?? '';
    for (let i = 0; i < allFigures.length; i++) {
      try {
        let figure = allFigures[i];
        let imgsrc = figure.getElementsByTagName('img')[0].src;
        await this.compressImage(imgsrc, figure.style.width).then((res: string) => {
          figure.getElementsByTagName('img')[0].src = res;
          htmlObject.getElementsByTagName('figure')[i].getElementsByTagName('img')[0].src = res;
          safeText = htmlObject.innerHTML;
        });
      } catch (error) {
        console.error('error: ', error);
      }
    }

    this.isspiner = true;
    let details = {
      FormAction: 'update',
      VALIDATEONLY: false,
      Data: { SIGNATUREDEFAULT: safeText },
    };
    this.sub1 = this._mainAPiServiceService.getSetData(details, 'preference').subscribe({
      next: (response) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.isspiner = false;
          this.toastr.success('Saved successfully');
        } else if (response.CODE == 451 && response.STATUS == 'warning') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else if (response.CODE == 450 && response.STATUS == 'error') {
          this.isspiner = false;
          this.toastr.error(response.MESSAGE);
        } else if (response.MESSAGE == 'Not logged in') {
          this.isspiner = false;
        }
        this.getData();
      },
      error: (error) => {
        this.isspiner = false;
        this.toastr.error(error);
      },
    });
  }

  /**
   * This function is used to
   */
  signaturePreview() {
    this.htmlCss = this.sanitizer.bypassSecurityTrustHtml(this.ckeditorValue);
  }

  /**
   * This function is used to Compress Image.
   */
  compressImage(src, percentageString) {
    let percentage = percentageString.split('%')[0];
    let newX, newY;
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        newY = (img.height * percentage) / 100;
        newX = (img.width * percentage) / 100;
        const elem = document.createElement('canvas');
        elem.width = newX;
        elem.height = newY;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, newX, newY);
        const data = ctx.canvas.toDataURL();

        res(data);
      };
      img.onerror = (error) => rej(error);
    });
  }
}
